(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9011],{

/***/ 6:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produto/[marca]/[produto]",
      function () {
        return __webpack_require__(4324);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(6856)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadable = _interop_require_default(__webpack_require__(4302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 6319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(9658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadableContext = __webpack_require__(6319);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(1688)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 7586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OfferBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Layout_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6008);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




function OfferBanner(param) {
    var _isOnHome = param.isOnHome, isOnHome = _isOnHome === void 0 ? false : _isOnHome, _phrase = param.phrase, phrase = _phrase === void 0 ? "Siga o Canal do CT no WhatsApp" : _phrase, _link = param.link, link = _link === void 0 ? "https://canalte.ch/canaltech-no-whatsapp-site" : _link;
    var textBanner = phrase;
    var Container = function(param) {
        var children = param.children;
        if (isOnHome) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative flex w-full flex-col flex-wrap content-center justify-center bg-mglGray50 pt-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full px-6 max-[500px]:pr-12",
                children: children
            })
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
            children: children
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex w-full items-center justify-center gap-2 rounded bg-[#25D366] p-4", !isOnHome && "mb-8"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: " text-sm leading-tight text-mglGray900 tablet:text-base",
                    children: textBanner
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: link,
                    target: "_blank",
                    className: "canal-ct-wpp flex appearance-none items-center gap-1 rounded-3xl border-0 bg-mglGray900 px-4 py-2 text-xs text-mglGray50 outline-none transition-opacity hover:opacity-80 focus:opacity-80",
                    title: textBanner,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            icon: "mdi:whatsapp"
                        }),
                        " Entrar"
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 7517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/Layout/Breadcrumb/styles.tsx




var BreadcrumbItemContainer = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex flex-row items-center font-light text-mglGray500 before:mr-2 before:flex before:h-[13px] before:w-2 before:items-center before:justify-center before:pb-[3px] before:text-center before:text-base before:leading-none before:content-['›'] first-of-type:before:content-none"
    }, props), {
        children: props.children
    }));
};
var BreadcrumbItem = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex h-4 flex-row items-center text-xs leading-4 text-mglGray500 no-underline"
    }, props), {
        ref: ref,
        children: props.children
    }));
});


// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/Layout/Breadcrumb/index.tsx
/* eslint-disable react/no-array-index-key */ 





var publicRuntimeConfig = config_default()().publicRuntimeConfig;
function Breadcrumb(param) {
    var breadcrumbList = param.breadcrumbList, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var breadcrumbSpan = currentSpan && currentSpan.startChild({
        op: "breadcrumb"
    });
    var workingList = (0,_to_consumable_array/* default */.Z)(breadcrumbList).filter(function(item) {
        return item.url !== "/";
    });
    workingList.unshift({
        titulo: "Home",
        url: "/"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "place-content-[center_start] mb-2 flex flex-wrap items-center gap-2",
        children: [
            workingList.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbItemContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: isSubDomain ? "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL).concat(item.url) : item.url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbItem, {
                            title: "Ir para ".concat(item.titulo),
                            children: item.titulo
                        })
                    })
                }, item.url);
            }),
            breadcrumbSpan && breadcrumbSpan.finish()
        ]
    });
}


/***/ }),

/***/ 2384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9659);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6008);







var variants = {
    sizes: {
        small: "h-6",
        medium: "h-9",
        large: "h-12"
    },
    backgroundColor: {
        white: "chip-bg-color [&.chip-bg-color]:bg-mglGray50",
        black: "chip-bg-color [&.chip-bg-color]:bg-mglGray900",
        green: "chip-bg-color [&.chip-bg-color]:bg-mglGreen500"
    },
    color: {
        black: "text-mglGray900",
        white: "chip-color [&.chip-color]:text-mglGray50 [&.chip-color]:[&_svg]:fill-mglGray50"
    },
    hover: {
        white: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray50 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        black: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray900 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50",
        gray: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray200 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        green: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGreen600 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50"
    },
    borderColor: {
        gray: "chip-border-color [&.chip-border-color]:border-mglGray900/20 hover:[&.chip-border-color]:border-mglGray50",
        black: "border-mglGray900/20",
        white: "chip-border-color [&.chip-border-color]:border-mglGray50/20",
        green: "chip-border-color [&.chip-border-color]:border-mglGreen500 hover:[&.chip-border-color]:border-mglGreen600"
    }
};
function Chip(param) {
    var texto = param.texto, prepIcon = param.prepIcon, posIcon = param.posIcon, _link = param.link, link = _link === void 0 ? "#" : _link, _color = param.color, color = _color === void 0 ? undefined : _color, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? undefined : _backgroundColor, backgroundImage = param.backgroundImage, _overlayOpacity = param.overlayOpacity, overlayOpacity = _overlayOpacity === void 0 ? 60 : _overlayOpacity, _chipSize = param.chipSize, chipSize = _chipSize === void 0 ? "small" : _chipSize, _borderColor = param.borderColor, borderColor = _borderColor === void 0 ? undefined : _borderColor, _title = param.title, title = _title === void 0 ? "" : _title, _highlightedText = param.highlightedText, highlightedText = _highlightedText === void 0 ? "" : _highlightedText, className = param.className, onClick = param.onClick, _hover = param.hover, hover = _hover === void 0 ? undefined : _hover, _rel = param.rel, rel = _rel === void 0 ? "" : _rel, _target = param.target, target = _target === void 0 ? "_self" : _target;
    var isValidLink = link[0] !== "#" && !/^\/\//.test(link) && link !== "";
    var Container = isValidLink ? (next_link__WEBPACK_IMPORTED_MODULE_2___default()) : react__WEBPACK_IMPORTED_MODULE_1__.Fragment;
    var Tag = link !== "#" && link !== "" ? "a" : "div";
    var linkProps = {};
    if (isValidLink) {
        Object.assign(linkProps, {
            href: link,
            passHref: true,
            prefetch: false
        });
    }
    var backgroundStyle = backgroundImage ? {
        backgroundImage: "linear-gradient(rgba(0, 0, 0, ".concat(overlayOpacity / 100, "), rgba(0, 0, 0, ").concat(overlayOpacity / 100, ")), url(").concat(backgroundImage, ")"),
        backgroundSize: "cover",
        backgroundPosition: "center"
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, linkProps), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, link && link !== "#" && {
            href: link
        }), {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative flex cursor-pointer flex-row flex-nowrap items-center justify-center overflow-hidden rounded-[100px] border border-solid px-4 no-underline transition-all ease-in [&_path]:transition-colors [&_path]:ease-ease", variants.sizes[chipSize], !backgroundImage && variants.backgroundColor[backgroundColor], variants.color[color], variants.borderColor[borderColor], variants.hover[hover], backgroundImage && "text-white", className),
            style: backgroundStyle,
            rel: rel,
            title: title,
            onClick: onClick,
            target: target,
            children: [
                !!prepIcon && typeof prepIcon === "string" && (prepIcon === "chevron-down" || prepIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(prepIcon),
                        width: 16
                    })
                }) : !!prepIcon && typeof prepIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: prepIcon
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "relative mt-[-2px] whitespace-nowrap text-center text-xs no-underline",
                            children: texto
                        }),
                        !!highlightedText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-base font-semibold leading-none",
                            children: highlightedText
                        })
                    ]
                }),
                !!posIcon && typeof posIcon === "string" && (posIcon === "chevron-down" || posIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1 [&_svg]:w-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(posIcon),
                        width: 16
                    })
                }) : !!posIcon && typeof posIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1",
                    children: posIcon
                })
            ]
        }))
    }));
}


/***/ }),

/***/ 1080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


function Container(param) {
    var children = param.children, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _className = param.className, className = _className === void 0 ? "" : _className;
    var variants = {
        hasBreadcrumb: {
            true: "mt-4 desktop:mt-10",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("w-full max-w-[calc(100%-2rem)] desktop:max-w-[83.33%]", variants.hasBreadcrumb[hasBreadcrumb.toString()], className),
        children: children
    });
}


/***/ }),

/***/ 3078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WrapperContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1080);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function WrapperContent(param) {
    var children = param.children, backgroundColor = param.backgroundColor, _isOnHeader = param.isOnHeader, isOnHeader = _isOnHeader === void 0 ? false : _isOnHeader, _paddingOnBottom = param.paddingOnBottom, paddingOnBottom = _paddingOnBottom === void 0 ? false : _paddingOnBottom, _paddingOnTop = param.paddingOnTop, paddingOnTop = _paddingOnTop === void 0 ? false : _paddingOnTop, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _mobileOnly = param.mobileOnly, mobileOnly = _mobileOnly === void 0 ? false : _mobileOnly, _desktopOnly = param.desktopOnly, desktopOnly = _desktopOnly === void 0 ? false : _desktopOnly, _className = param.className, className = _className === void 0 ? undefined : _className;
    var variants = {
        isOnHeader: {
            true: "isOnHeader [&.isOnHeader]:p-0",
            false: ""
        },
        paddingOnBottom: {
            true: "paddingOnBottom [&.paddingOnBottom]:pb-10",
            false: "pb-0"
        },
        paddingOnTop: {
            true: "paddingOnTop [&.paddingOnTop]:pt-10",
            false: ""
        },
        mobileOnly: {
            true: "flex desktop:hidden",
            false: ""
        },
        desktopOnly: {
            true: "hidden desktop:flex",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: {
            backgroundColor: backgroundColor || _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
        },
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative flex w-full flex-col flex-wrap content-center justify-center px-0 py-10", variants.isOnHeader[isOnHeader.toString()], variants.paddingOnBottom[paddingOnBottom.toString()], variants.paddingOnTop[paddingOnTop.toString()], variants.mobileOnly[mobileOnly.toString()], variants.desktopOnly[desktopOnly.toString()]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            hasBreadcrumb: hasBreadcrumb,
            className: className,
            children: children
        })
    });
}


/***/ }),

/***/ 804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var PageDataContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
/* harmony default export */ __webpack_exports__["Z"] = (PageDataContext);


/***/ }),

/***/ 4324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ TechnicalSpecs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/Layout/index.tsx + 15 modules
var Layout = __webpack_require__(7590);
// EXTERNAL MODULE: ./src/components/Layout/WrapperContent/index.tsx
var WrapperContent = __webpack_require__(3078);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/components/Layout/Chip/index.tsx
var Chip = __webpack_require__(2384);
// EXTERNAL MODULE: ./src/components/Internals/NewsContent/styles.tsx
var styles = __webpack_require__(2657);
// EXTERNAL MODULE: ./src/utils/currencyParser.ts
var currencyParser = __webpack_require__(8745);
// EXTERNAL MODULE: ./src/components/Internals/ContentComposer/index.tsx + 1 modules
var ContentComposer = __webpack_require__(944);
// EXTERNAL MODULE: ./src/components/Layout/Breadcrumb/index.tsx + 1 modules
var Breadcrumb = __webpack_require__(7517);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/assets/svg/ProductChips/analysis.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgAnalysis(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M3 0h13a3 3 0 013 3v9a3 3 0 01-3 3h-3.5l-3 3-3-3H3a3 3 0 01-3-3V3a3 3 0 013-3zm0 1a2 2 0 00-2 2v9a2 2 0 002 2h3.914L9.5 16.586 12.086 14H16a2 2 0 002-2V3a2 2 0 00-2-2H3zm0 3h13v1H3V4zm0 3h12v1H3V7zm0 3h8v1H3v-1z",
    fill: "#000"
  })));
}
/* harmony default export */ var ProductChips_analysis = (SvgAnalysis);
;// CONCATENATED MODULE: ./src/assets/svg/ProductChips/overview.svg
var overview_path;
var overview_excluded = ["title", "titleId"];
function overview_extends() { overview_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return overview_extends.apply(this, arguments); }
function overview_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = overview_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function overview_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgOverview(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = overview_objectWithoutProperties(_ref, overview_excluded);
  return /*#__PURE__*/react.createElement("svg", overview_extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, overview_path || (overview_path = /*#__PURE__*/react.createElement("path", {
    d: "M10 8a3 3 0 01-3-3V1H3a2 2 0 00-2 2v13a2 2 0 002 2h9a2 2 0 002-2V8h-4zM8 5a2 2 0 002 2h3.586L8 1.414V5zM3 0h5l7 7v9a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3z",
    fill: "#000"
  })));
}
/* harmony default export */ var overview = (SvgOverview);
;// CONCATENATED MODULE: ./src/assets/svg/ProductChips/news.svg
var news_path;
var news_excluded = ["title", "titleId"];
function news_extends() { news_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return news_extends.apply(this, arguments); }
function news_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = news_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function news_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgNews(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = news_objectWithoutProperties(_ref, news_excluded);
  return /*#__PURE__*/react.createElement("svg", news_extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, news_path || (news_path = /*#__PURE__*/react.createElement("path", {
    d: "M14 8a3 3 0 01-3-3V1H3a2 2 0 00-2 2v11a2 2 0 002 2h13a2 2 0 002-2V8h-4zm-2-3a2 2 0 002 2h3.586L12 1.414V5zM3 0h9l7 7v7a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm0 4h6v1H3V4zm0 4h6v1H3V8zm0 4h13v1H3v-1z",
    fill: "#000"
  })));
}
/* harmony default export */ var news = (SvgNews);
;// CONCATENATED MODULE: ./src/assets/svg/ProductChips/deals.svg
var deals_path;
var deals_excluded = ["title", "titleId"];
function deals_extends() { deals_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return deals_extends.apply(this, arguments); }
function deals_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = deals_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function deals_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgDeals(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = deals_objectWithoutProperties(_ref, deals_excluded);
  return /*#__PURE__*/react.createElement("svg", deals_extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, deals_path || (deals_path = /*#__PURE__*/react.createElement("path", {
    d: "M4 0h1v2.01C8.29 2.151 9 3.695 9 5H8c0-1.327-1.178-2-3.5-2C3.68 3 1 3.163 1 5.249c0 .872 0 1.86 3.621 2.766l1.606.485C8.76 9.435 9 10.572 9 11.751c0 1.881-1.518 3.093-4 3.235V17H4v-2.01C.71 14.849 0 13.305 0 12h1c0 1.327 1.178 2 3.5 2 .82 0 3.5-.163 3.5-2.249 0-.872 0-1.86-3.621-2.766L2.773 8.5C.24 7.565 0 6.428 0 5.249c0-1.881 1.518-3.093 4-3.235V0z",
    fill: "#000"
  })));
}
/* harmony default export */ var deals = (SvgDeals);
;// CONCATENATED MODULE: ./src/assets/svg/ProductChips/chipHamburger.svg
var chipHamburger_path;
var chipHamburger_excluded = ["title", "titleId"];
function chipHamburger_extends() { chipHamburger_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chipHamburger_extends.apply(this, arguments); }
function chipHamburger_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = chipHamburger_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function chipHamburger_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgChipHamburger(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = chipHamburger_objectWithoutProperties(_ref, chipHamburger_excluded);
  return /*#__PURE__*/react.createElement("svg", chipHamburger_extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, chipHamburger_path || (chipHamburger_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 1.017V0h17v1.017H0zm0 4.068V4.068h17v1.017H0zm0 4.068V8.136h17v1.017H0zm0 4.067v-1.017h17v1.017H0zm0 4.068v-1.017h17v1.017H0z",
    fill: "#fff"
  })));
}
/* harmony default export */ var chipHamburger = (SvgChipHamburger);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./src/utils/className.ts
var className = __webpack_require__(9659);
;// CONCATENATED MODULE: ./src/components/Product/ProductChips/styles.tsx





var variants = {
    ChipParent: {
        selected: {
            true: "selected [&.selected>div]:bg-mglGray300 [&.selected>a]:bg-mglGray300"
        },
        greenBackground: {
            true: "[&>a]:hover:bg-mglGreen600"
        }
    },
    ChipMenuDropdown: {
        isOpen: {
            true: "opacity-100",
            false: "opacity-0 pointer-events-none"
        }
    },
    ChipMenuDropdownItem: {
        selected: {
            true: "selected [&.selected]:bg-mglGray300 [&.selected]:text-mglGray900 [&_path]:[&.selected]:fill-mglGray900"
        }
    }
};
var ChipParent = function(_param) {
    var children = _param.children, _selected = _param.selected, selected = _selected === void 0 ? false : _selected, _greenBackground = _param.greenBackground, greenBackground = _greenBackground === void 0 ? false : _greenBackground, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "selected",
        "greenBackground"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,className/* default */.Z)("hidden tablet:flex", variants.ChipParent.greenBackground[greenBackground.toString()], variants.ChipParent.selected[selected.toString()])
    }, props), {
        children: children
    }));
};
/* harmony default export */ var ProductChips_styles = ({
    ChipParent: ChipParent
});

// EXTERNAL MODULE: ./src/components/Layout/Icon/index.tsx
var Icon = __webpack_require__(6008);
;// CONCATENATED MODULE: ./src/components/Product/ProductChips/index.tsx












function ProductChips(param) {
    var _analysis = param.analysis, analysis = _analysis === void 0 ? undefined : _analysis, _hasDeals = param.hasDeals, hasDeals = _hasDeals === void 0 ? false : _hasDeals, _hasOverview = param.hasOverview, hasOverview = _hasOverview === void 0 ? false : _hasOverview, _hasNews = param.hasNews, hasNews = _hasNews === void 0 ? false : _hasNews, minorValue = param.minorValue, _sponsoredChip = param.sponsoredChip, sponsoredChip = _sponsoredChip === void 0 ? false : _sponsoredChip;
    var ref;
    var ChipValues = [
        {
            key: "review",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductChips_analysis, {}),
            label: "review",
            visible: analysis !== undefined,
            link: analysis
        },
        {
            key: "ficha-tecnica",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(overview, {}),
            label: "ficha t\xe9cnica",
            visible: hasOverview,
            link: "#ficha-tecnica"
        },
        {
            key: "noticias",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(news, {}),
            label: "not\xedcias",
            visible: true,
            link: "#noticias"
        },
        {
            key: "ofertas",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(deals, {}),
            label: "pre\xe7os",
            visible: hasDeals,
            link: "#precos"
        }, 
    ];
    var ref1 = (0,react.useState)((ref = ChipValues.find(function(e) {
        return e.visible;
    })) === null || ref === void 0 ? void 0 : ref.key), selectedChip = ref1[0], setSelectedChip = ref1[1];
    var ref2 = (0,react.useState)(false), isDropdownOpen = ref2[0], setIsDropdownOpen = ref2[1];
    var currentChip = ChipValues.find(function(values) {
        return values.key === selectedChip;
    });
    var backgroundChipUrl = "https://t.ctcdn.com.br/QFdnjPQOAnsY-aHSkABkXT-BcN4=/i1068821.jpeg";
    (0,react.useEffect)(function() {
        var ref;
        setSelectedChip((ref = ChipValues.find(function(e) {
            return e.visible;
        })) === null || ref === void 0 ? void 0 : ref.key);
    }, [
        analysis,
        hasDeals,
        hasNews,
        hasOverview
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mb-8 flex flex-wrap gap-4 [&>div:last>*]:hidden tablet:[&>div:last>*]:flex [&>div>*]:flex [&>div>*]:max-w-[153px] [&>div>*]:gap-x-2 [&>div>*]:rounded-[100px] [&>div>*]:px-12 [&>div>*]:py-3",
                children: [
                    analysis && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipParent, {
                        role: "tab",
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                            chipSize: "large",
                            prepIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductChips_analysis, {}),
                            color: "black",
                            borderColor: "gray",
                            backgroundColor: "white",
                            texto: "review",
                            link: analysis,
                            hover: "gray"
                        })
                    }),
                    hasOverview && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipParent, {
                        role: "tab",
                        tabIndex: 0,
                        onKeyPress: function(event) {
                            event.preventDefault();
                            if (event.key === "enter") setSelectedChip("ficha-tecnica");
                        },
                        selected: selectedChip === "ficha-tecnica",
                        onClick: function() {
                            return selectedChip !== "ficha-tecnica" && setSelectedChip("ficha-tecnica");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                            chipSize: "large",
                            prepIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(overview, {}),
                            color: "black",
                            borderColor: "gray",
                            backgroundColor: "white",
                            texto: "ficha t\xe9cnica",
                            link: "#ficha-tecnica",
                            hover: "gray"
                        })
                    }),
                    hasNews && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipParent, {
                        role: "tab",
                        tabIndex: 0,
                        onKeyPress: function(event) {
                            event.preventDefault();
                            if (event.key === "enter") setSelectedChip("noticias");
                        },
                        selected: selectedChip === "noticias",
                        onClick: function() {
                            return selectedChip !== "noticias" && setSelectedChip("noticias");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                            chipSize: "large",
                            prepIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(news, {}),
                            color: "black",
                            borderColor: "gray",
                            backgroundColor: "white",
                            texto: "not\xedcias",
                            link: "#noticias",
                            hover: "gray"
                        })
                    }),
                    hasDeals && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipParent, {
                        role: "tab",
                        tabIndex: 0,
                        onKeyPress: function(event) {
                            event.preventDefault();
                            if (event.key === "enter") setSelectedChip("ofertas");
                        },
                        selected: selectedChip === "ofertas",
                        onClick: function() {
                            return selectedChip !== "ofertas" && setSelectedChip("ofertas");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                            chipSize: "large",
                            prepIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(deals, {}),
                            color: "black",
                            borderColor: "gray",
                            backgroundColor: "white",
                            texto: "pre\xe7os",
                            link: "#precos",
                            hover: "gray"
                        })
                    }),
                    hasDeals && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipParent, {
                        greenBackground: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                            chipSize: "large",
                            color: "white",
                            backgroundColor: "green",
                            borderColor: "green",
                            highlightedText: (0,currencyParser/* default */.Z)(minorValue.preco),
                            texto: "melhor pre\xe7o",
                            posIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                icon: "mdi:open-in-new",
                                fontSize: "0.75rem"
                            }),
                            link: minorValue.encurtador
                        })
                    }),
                    sponsoredChip && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipParent, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                            chipSize: "large",
                            link: "https://ofertas.canaltech.com.br/marca/oppo/",
                            target: "_blank",
                            backgroundImage: backgroundChipUrl,
                            texto: "OFERTAS OPPO",
                            posIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                icon: "mdi:open-in-new",
                                fontSize: "0.75rem"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mb-4 flex flex-row items-center gap-x-4 rounded-[100px] bg-mglGray300 px-5 py-3 text-mglGray900 no-underline transition-all duration-300 ease-ease md:mb-8 tablet:hidden [&>span>svg>path]:fill-mglGray900",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "relative flex",
                        children: currentChip && currentChip.icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "relative mt-[-2px] whitespace-nowrap text-center text-base no-underline",
                        children: currentChip && currentChip.label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "relative ml-auto flex",
                        onClick: function() {
                            return setIsDropdownOpen(!isDropdownOpen);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chipHamburger, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (0,className/* default */.Z)("shadow-[0px 2px 5px 0px rgba(0, 0, 0, 0.3)] absolute left-0 top-0 z-50 w-full flex-col gap-y-2 rounded-xl bg-mglGray50 transition-all duration-300 ease-ease", variants.ChipMenuDropdown.isOpen[isDropdownOpen.toString()]),
                        children: ChipValues.map(function(value) {
                            return value.visible && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: value.link,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: (0,className/* default */.Z)("relative mt-1 flex items-center gap-x-4 rounded-[100px] border border-solid border-mglGray200 bg-mglGray100 px-5 py-3 text-mglGray900 no-underline transition-all duration-300 ease-ease hover:bg-mglGray200 hover:text-mglGray900 [&>span>svg>path]:fill-mglGray900 [&>span>svg>path]:hover:fill-mglGray900 [&>span>svg]:w-[19px]", variants.ChipMenuDropdownItem.selected[(selectedChip === value.key).toString()]),
                                    onClick: function() {
                                        setSelectedChip(value.key);
                                        setIsDropdownOpen(false);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "relative flex",
                                            children: value.icon
                                        }),
                                        value.label
                                    ]
                                }, value.key)
                            }, value.key);
                        })
                    })
                ]
            }),
            sponsoredChip && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                chipSize: "large",
                backgroundImage: backgroundChipUrl,
                className: "md:hidden",
                texto: "OFERTAS OPPO",
                link: "https://ofertas.canaltech.com.br/",
                target: "_blank",
                posIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    icon: "mdi:open-in-new",
                    fontSize: "0.75rem"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/styles/designSystemColors.ts
var designSystemColors = __webpack_require__(9642);
// EXTERNAL MODULE: ./src/components/Internals/OfferBanner/index.tsx
var OfferBanner = __webpack_require__(7586);
// EXTERNAL MODULE: ./src/hooks/useBreakpoint.ts
var useBreakpoint = __webpack_require__(2140);
// EXTERNAL MODULE: ./src/components/Layout/Image/index.tsx + 1 modules
var Image = __webpack_require__(2153);
;// CONCATENATED MODULE: ./src/components/Product/Header/index.tsx
/* eslint-disable array-callback-return */ 













function Header(param) {
    var dataHeader = param.dataHeader;
    var ref;
    var _data = dataHeader.data, breadcrumb = _data.breadcrumb, imagem = _data.imagem, empresa = _data.empresa, titulo = _data.titulo, descricao = _data.descricao, lancamento = _data.lancamento, especificacoesCabecalho = _data.especificacoesCabecalho, melhoresPrecos = _data.melhoresPrecos, analise = _data.analise, fichaTecnica = _data.fichaTecnica, timeline = _data.timeline, rumor = _data.rumor;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("tablet"), 1), isTabletOrMobile = ref1[0];
    var sponsoredBrandName = "Oppo";
    var isSponsoredBrand = empresa === sponsoredBrandName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
        backgroundColor: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50,
        isOnHeader: true,
        hasBreadcrumb: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferBanner/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
                breadcrumbList: breadcrumb
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-0 mt-8 flex w-full flex-col tablet:mb-8 tablet:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative flex max-h-[148px] max-w-[148px] rounded-lg border-[0.5px] border-solid border-mglGray300 p-6 md:max-h-[248px] md:max-w-[248px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: imagem.url,
                                        blurhash: imagem.blurhash,
                                        width: isTabletOrMobile ? 80 : 190,
                                        height: isTabletOrMobile ? 80 : 190
                                    }),
                                    rumor && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "absolute bottom-[1.75em] left-0 right-0 m-auto w-[3.375rem] rounded-lg bg-[#e8384f] text-center text-xs uppercase leading-loose text-mglGray50",
                                        children: "Rumor"
                                    })
                                ]
                            }),
                            melhoresPrecos && (melhoresPrecos === null || melhoresPrecos === void 0 ? void 0 : melhoresPrecos.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml-4 flex tablet:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                    chipSize: "large",
                                    color: "white",
                                    backgroundColor: "green",
                                    borderColor: "green",
                                    highlightedText: (0,currencyParser/* default */.Z)(melhoresPrecos[0].preco),
                                    texto: "melhor pre\xe7o",
                                    posIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        icon: "mdi:open-in-new",
                                        fontSize: "0.75rem"
                                    }),
                                    link: melhoresPrecos[0].encurtador
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-6 flex w-full flex-col gap-1 tablet:ml-6 tablet:mt-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative mb-4 flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-sm font-light text-mglGray900",
                                        children: empresa
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "font-medium text-mglGray900",
                                        children: titulo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex w-full flex-col justify-between tablet:flex-row [&_p+p]:flex-grow-[2] [&_p]:flex-grow-[2]",
                                        children: (lancamento === null || lancamento === void 0 ? void 0 : lancamento.data) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-sm font-light",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "mr-1 font-medium capitalize",
                                                    children: "Lan\xe7amento:"
                                                }),
                                                " ",
                                                new Intl.DateTimeFormat("pt-Br", {
                                                    timeZone: "UTC"
                                                }).format(new Date(lancamento.data))
                                            ]
                                        })
                                    })
                                ]
                            }),
                            especificacoesCabecalho && Object.keys(especificacoesCabecalho).map(function(specName) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-sm font-light",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "mr-1 font-medium capitalize",
                                            children: [
                                                specName,
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        especificacoesCabecalho[specName]
                                    ]
                                }, specName);
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductChips, {
                hasDeals: melhoresPrecos && (melhoresPrecos === null || melhoresPrecos === void 0 ? void 0 : melhoresPrecos.length) > 0,
                analysis: analise === null || analise === void 0 ? void 0 : analise.url,
                hasOverview: !!fichaTecnica,
                hasNews: timeline && (timeline === null || timeline === void 0 ? void 0 : (ref = timeline.itens) === null || ref === void 0 ? void 0 : ref.length) > 0,
                minorValue: melhoresPrecos ? melhoresPrecos[0] : null,
                sponsoredChip: isSponsoredBrand
            }, "lower-price"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-8 mt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* DivContentNews */._7, {
                    children: descricao.map(function(partHtml) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ContentComposer/* default */.Z, {
                            tipo: partHtml.tipo,
                            as: partHtml.tag,
                            url: partHtml.url,
                            target: partHtml.target,
                            valor: partHtml === null || partHtml === void 0 ? void 0 : partHtml.valor,
                            atributos: partHtml === null || partHtml === void 0 ? void 0 : partHtml.atributos
                        }, "".concat(partHtml.tipo));
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/produto/[marca]/[produto]/index.tsx







var PriceHistoryChart = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6133).then(__webpack_require__.bind(__webpack_require__, 6133));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6133)
            ];
        }
    },
    ssr: false
});
var DealsBox = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8387).then(__webpack_require__.bind(__webpack_require__, 8387));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8387)
            ];
        }
    },
    ssr: false
});
var Specifications = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3269).then(__webpack_require__.bind(__webpack_require__, 3269));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3269)
            ];
        }
    },
    ssr: false
});
var FeaturedLastNews = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2826), __webpack_require__.e(24)]).then(__webpack_require__.bind(__webpack_require__, 2826));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2826)
            ];
        }
    },
    ssr: false
});
var HighlightAnalysis = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3257).then(__webpack_require__.bind(__webpack_require__, 3257));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3257)
            ];
        }
    }
});
var VideoSliders = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3213), __webpack_require__.e(7637), __webpack_require__.e(167)]).then(__webpack_require__.bind(__webpack_require__, 167));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(167)
            ];
        }
    }
});
var FeaturedProducts = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3213), __webpack_require__.e(7637), __webpack_require__.e(1050)]).then(__webpack_require__.bind(__webpack_require__, 2909));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2909)
            ];
        }
    }
});
var __N_SSP = true;
function TechnicalSpecs(param) {
    var navBarData = param.navBarData, tagsData = param.tagsData, responseData = param.responseData, marca = param.marca, produto = param.produto;
    var _data = responseData.data, titulo = _data.titulo, empresa = _data.empresa, videosRelacionados = _data.videosRelacionados, analise = _data.analise, fichaTecnica = _data.fichaTecnica, produtosEmpresa = _data.produtosEmpresa, melhoresPrecos = _data.melhoresPrecos, historicoPrecos = _data.historicoPrecos;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        layoutData: {
            tagsData: tagsData,
            navBarData: navBarData,
            schema: responseData.schema
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                dataHeader: responseData
            }),
            (analise === null || analise === void 0 ? void 0 : analise.video) || videosRelacionados && videosRelacionados.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
                backgroundColor: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50,
                paddingOnBottom: false,
                children: [
                    (analise === null || analise === void 0 ? void 0 : analise.video) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                id: "analise"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightAnalysis, {
                                title: titulo,
                                video: {
                                    id: analise.video.idYoutube,
                                    title: "V\xeddeo-an\xe1lise - ".concat(analise.video.titulo)
                                }
                            })
                        ]
                    }),
                    videosRelacionados && videosRelacionados.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSliders, {
                        featuredVideosData: videosRelacionados,
                        isOnProduct: true,
                        setBackgroundColor: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50,
                        useTitle: true
                    })
                ]
            }) : null,
            melhoresPrecos && melhoresPrecos.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.ZP, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        id: "precos"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DealsBox, {
                        link: "",
                        produto: titulo,
                        deals: melhoresPrecos,
                        isProduct: true
                    }, titulo)
                ]
            }),
            historicoPrecos && historicoPrecos.historico && historicoPrecos.historico.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceHistoryChart, {
                historyData: historicoPrecos
            }),
            fichaTecnica && /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.ZP, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        id: "ficha-tecnica"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Specifications, {
                        fichaTecnica: fichaTecnica
                    })
                ]
            }),
            produtosEmpresa && produtosEmpresa.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProducts, {
                    featuredProductsData: produtosEmpresa,
                    title: "Produtos ".concat(empresa || "relacionados"),
                    bgColor: designSystemColors/* mglGray.mglGray200 */.Ce.mglGray200,
                    indexComponent: "produtosEmpresa"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.ZP, {
                height: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        id: "noticias"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedLastNews, {
                        featuredLastNewsData: null,
                        rootPage: "produto/".concat(marca, "/").concat(produto),
                        textTitle: "\xdaltimas sobre ".concat(titulo),
                        headingTag: "h2",
                        noPagination: true,
                        route: "produto/".concat(marca, "/").concat(produto),
                        routeType: "produto"
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 8745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ currencyParser; }
/* harmony export */ });
function currencyParser(value) {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
    }).format(value);
}


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(638)


/***/ }),

/***/ 3250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(7294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 1688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3250);
} else {}


/***/ }),

/***/ 2222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [162,1216,8912,8802,7590,944,9774,2888,179], function() { return __webpack_exec__(6); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);